<button
  class="back-button__icon"
  (click)="navigateBack()">
  <mat-icon svgIcon="chevronLeft"></mat-icon>
  {{ title() | translate }}
</button>
